import pkg from '../../package.json';
const { version } = pkg;

const STORAGE_VERSION_KEY = 'app_schema_version';

const migrations = {
  '1.0.0': (storage) => {
    // Placeholder — versão base, nenhuma migração necessária
    return storage;
  },
  '2.0.0': (storage) => {
    // user_token passou a incluir campo "roles"
    const raw = storage.getItem('user_token');
    if (raw) {
      try {
        const user = JSON.parse(raw);
        if (!Array.isArray(user.roles)) {
          user.roles = [];
          storage.setItem('user_token', JSON.stringify(user));
        }
      } catch {
        storage.removeItem('user_token');
      }
    }
    return storage;
  },
  '3.0.0': (storage) => {
    // sidebarOpen/sidebarCollapsed podem ter vindo como string em versões antigas
    ['sidebarOpen', 'sidebarCollapsed'].forEach((key) => {
      const val = storage.getItem(key);
      if (val === 'true' || val === 'false') {
        storage.setItem(key, JSON.stringify(val === 'true'));
      }
    });
    return storage;
  },
};

function parseVersion(v) {
  return v.split('.').map(Number);
}

function isNewerThan(a, b) {
  const [aMajor, aMinor, aPatch] = parseVersion(a);
  const [bMajor, bMinor, bPatch] = parseVersion(b);
  if (aMajor !== bMajor) return aMajor > bMajor;
  if (aMinor !== bMinor) return aMinor > bMinor;
  return aPatch > bPatch;
}

export function migrateLocalStorage() {
  try {
    const storedVersion = localStorage.getItem(STORAGE_VERSION_KEY) || '0.0.0';

    if (storedVersion === version) return;

    const versionsToRun = Object.keys(migrations)
      .filter((v) => isNewerThan(v, storedVersion))
      .sort((a, b) => (isNewerThan(a, b) ? 1 : -1));

    versionsToRun.forEach((v) => {
      try {
        migrations[v](localStorage);
        console.log(`[Migration] Applied schema migration for version ${v}`);
      } catch (err) {
        console.error(`[Migration] Failed migration for version ${v}:`, err);
      }
    });

    localStorage.setItem(STORAGE_VERSION_KEY, version);
  } catch (err) {
    console.error('[Migration] localStorageMigration failed:', err);
  }
}
